import _noop from "lodash/noop";

import { CUSTOM_EVENTS } from "@/constants/custom-events";
import { dispatchCustomEvent } from "@/helpers/events";
import {
  ChatReceivedWebsocketEventI,
  MessagesWebsocketEventI,
} from "@/lib/types/messaging";
import { getWebsocketInstance } from "@/helpers/websockets";
import {
  WEBSOCKET_CONNECTION_TYPES,
  WEBSOCKET_EVENT_TYPES,
} from "@/lib/websockets/constants";

export const messagingSocketEventHandler = {
  receiveMessage: ({ data }: MessagesWebsocketEventI) => {
    dispatchCustomEvent({
      eventType: CUSTOM_EVENTS.WEBSOCKETS.MESSAGING.MESSAGE_RECEIVE,
      data,
    });
  },
  receiveChat: ({ data }: ChatReceivedWebsocketEventI) => {
    dispatchCustomEvent({
      eventType: CUSTOM_EVENTS.WEBSOCKETS.MESSAGING.CHAT_RECEIVE,
      data,
    });
  },
  sendMessage: (message: string) => {
    const ws = getWebsocketInstance(
      WEBSOCKET_CONNECTION_TYPES.GENERAL
    ) as WebSocket;

    if (!ws) {
      console.error("Failed to send a message - no websocket connection");
      return;
    }

    if (ws?.readyState === WebSocket.OPEN) {
      console.debug("SENDING A MESSAGE");
      ws?.send(
        JSON.stringify({
          msg_type: WEBSOCKET_EVENT_TYPES.CHAT,
          msg_chat: {
            message: message,
          },
        })
      );
    }
  },
  enterChatV2: (campaignId: string, customerId: string, userId: string) => {
    const ws = getWebsocketInstance(
      WEBSOCKET_CONNECTION_TYPES.GENERAL
    ) as WebSocket;

    if (!ws) {
      return;
    }

    const onSocketReady = () => {
      ws.send(
        JSON.stringify({
          msg_type: WEBSOCKET_EVENT_TYPES.ENTER_CHAT_V2,
          msg_enter_chat_v2: {
            campaign_id: campaignId,
            customer_id: customerId,
            user_id: userId,
          },
        })
      );

      console.debug("[CHAT] Chat room has been entered");
    };

    if (ws.readyState === WebSocket.OPEN) {
      onSocketReady();

      return _noop;
    }

    ws.addEventListener("open", onSocketReady);

    return () => {
      ws.removeEventListener("open", onSocketReady);
    };
  },
};
